import { Locale } from '@org-avp/avp-hck-dga-customerui-commons';
import { resources } from '@/i18n/i18n';

export const getI18nLocale = (locale: Locale): Locale => {
  if (!locale) {
    return Locale.en;
  }
  const i18nLocale = locale.replace('_', '-') as Locale;

  return Object.keys(resources).includes(i18nLocale) ? i18nLocale : Locale.en;
};
